import i18n from 'services/base/i18n';

export default {
  severity:  () => i18n.pgettext('Pages|List Issues|Issue Item', 'Severity'),
  affected:  () => i18n.pgettext('Pages|List Issues|Issue Item', 'Affected'),
  incidents: () => i18n.pgettext('Pages|List Issues|Issue Item', 'Incidents'),
};
